// App configuration based on deployment environment

export interface AppConfig {
  showDemoMode: boolean;
  showModeToggle: boolean;
  defaultMode: 'platform' | 'simple';
  apiUrl: string;
  appName: string;
  environment: 'development' | 'staging' | 'production';
}

// Determine environment based on hostname
const getEnvironmentConfig = (): AppConfig => {
  const hostname = window.location.hostname;
  
  // Production app subdomain - REAL app only
  if (hostname === 'app.honeydolist.vip') {
    return {
      showDemoMode: false,
      showModeToggle: false,
      defaultMode: 'platform',
      apiUrl: process.env.REACT_APP_API_URL || 'https://lyr98uple4.execute-api.us-east-2.amazonaws.com/dev',
      appName: 'HoneyDo Platform',
      environment: 'production'
    };
  }

  // Marketing/demo site
  if (hostname === 'honeydolist.vip' || hostname === 'demo.honeydolist.vip') {
    return {
      showDemoMode: true,
      showModeToggle: true,
      defaultMode: 'simple',
      apiUrl: process.env.REACT_APP_API_URL || 'https://lyr98uple4.execute-api.us-east-2.amazonaws.com/dev',
      appName: 'HoneyDo Demo',
      environment: 'production'
    };
  }

  // Local development
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return {
      showDemoMode: true,
      showModeToggle: true,
      defaultMode: 'platform',
      apiUrl: process.env.REACT_APP_API_URL || 'https://lyr98uple4.execute-api.us-east-2.amazonaws.com/dev',
      appName: 'HoneyDo Development',
      environment: 'development'
    };
  }

  // Default (staging or other)
  return {
    showDemoMode: true,
    showModeToggle: true,
    defaultMode: 'platform',
    apiUrl: process.env.REACT_APP_API_URL || 'https://lyr98uple4.execute-api.us-east-2.amazonaws.com/dev',
    appName: 'HoneyDo',
    environment: 'staging'
  };
};

export const appConfig = getEnvironmentConfig();

// Helper functions
export const isProductionApp = () => appConfig.environment === 'production' && !appConfig.showDemoMode;
export const isDemoSite = () => appConfig.showDemoMode && appConfig.defaultMode === 'simple';
export const isDevelopment = () => appConfig.environment === 'development';

// Marketing site CTA routing configuration (Tim-Combo AgentDeploymentOrchestrator pattern)
export const getAppUrl = () => 'https://app.honeydolist.vip';
export const getDemoUrl = () => 'https://demo.honeydolist.vip';
export const isMarketingSite = () => window.location.hostname === 'honeydolist.vip';